// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"join-team-banner_bannerContainer_QG9","joinTeamBanner":"join-team-banner_joinTeamBanner_1uM","shareBannerFacePile":"join-team-banner_shareBannerFacePile_iFa"};